export const DOM_ELEMENTS = [
    'article',
    'aside',
    'blockquote',
    'button',
    'cite',
    'caption',
    'circle',
    'code',
    'dd',
    'div',
    'dl',
    'dt',
    'figcaption',
    'fieldset',
    'figure',
    'footer',
    'form',
    'header',
    'hr',
    'img',
    'input',
    'kbd',
    'label',
    'li',
    'main',
    'mark',
    'nav',
    'ol',
    'path',
    'pre',
    'q',
    'rect',
    's',
    'svg',
    'section',
    'select',
    'small',
    'span',
    'sub',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'tr',
    'ul'
];
export const FOCUSABLE_ELEMENTS = [
    'a, button, textarea, input, select'
];
//# sourceMappingURL=elements.js.map